export default __webpack_public_path__ + "static/media/5-10_icon.b35a3872.svg";